import type { ReactNode } from "react"

interface VoiceWidgetShellProps {
  // Layout shape only — the SDK connection, ActionCable
  // subscription, and call logic stay shared at the page
  // level (CLAUDE.md "Build for every viewport"). This branch
  // owns chrome alone.
  isMobile: boolean
  children: ReactNode
}

// The deliberately-dark call surface (CON-155). Desktop: a
// 324px card docked bottom-right. Mobile: a bottom sheet —
// rounded top, drag handle, safe-area inset. Both share the
// same inner widget content; only the container shape branches.
//
// The colors here are intentionally NOT theme tokens — the
// widget is a fixed dark surface regardless of app theme.
// CON-158 (post-call card) and CON-159 (transcript) reuse this
// shell so the dark chrome stays consistent across the live →
// post-call → transcript flow.
//
// One element tree for both shapes: returning two different
// JSX trees remounted `children` on every viewport flip (React
// reconciles by position), wiping the after-call card's local
// state mid-resize (CON-211). The drag handle sits in a stable
// conditional slot instead.
export function VoiceWidgetShell({
  isMobile,
  children,
}: VoiceWidgetShellProps) {
  return (
    <div
      className={
        isMobile
          ? "overflow-clip rounded-t-[24px] bg-[#1E1B17] pb-[env(safe-area-inset-bottom)] shadow-[0_18px_48px_#1E1B1747]"
          : "w-[324px] overflow-clip rounded-[18px] bg-[#1E1B17] shadow-[0_18px_48px_#1E1B1747]"
      }
    >
      {isMobile ? (
        <div className="flex justify-center pt-3">
          <div
            aria-hidden="true"
            className="h-1 w-9 rounded-full bg-[#48433B]"
          />
        </div>
      ) : null}
      {children}
    </div>
  )
}
